/**
 * Birthday window check (041) — client mirror of the server's
 * api/_lib/stamp-bonus.ts birthdayYearInWindow (±3 days, UTC, year-wrap
 * aware). Keep the two in sync if the window ever changes.
 */
export function birthdayInWindow(month: number, day: number, now = new Date(), windowDays = 3): boolean {
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  for (const year of [now.getUTCFullYear() - 1, now.getUTCFullYear(), now.getUTCFullYear() + 1]) {
    const bday = Date.UTC(year, month - 1, day);
    if (Math.abs(today - bday) / 86_400_000 <= windowDays) return true;
  }
  return false;
}
